export default {
  aproved: 'APPROVED',
  rejected: 'REJECTED',
  pending: 'PENDING',
  conditional: 'CONDITIONAL',
  review: 'IN_REVIEW',
  regular: 'REGULAR'
};
